var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_947_26841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5007 1.6901C13.0859 1.69003 13.6608 1.84404 14.1677 2.13665C14.6745 2.42926 15.0954 2.85016 15.3879 3.35701C15.6805 3.86387 15.8345 4.43882 15.8344 5.02406C15.8343 5.60929 15.6801 6.18419 15.3873 6.69093L19.1673 6.6901V8.35677H17.5006V16.6901C17.5006 16.9111 17.4129 17.1231 17.2566 17.2794C17.1003 17.4356 16.8883 17.5234 16.6673 17.5234H3.33398C3.11297 17.5234 2.90101 17.4356 2.74473 17.2794C2.58845 17.1231 2.50065 16.9111 2.50065 16.6901V8.35677H0.833984V6.6901L4.61398 6.69093C4.20054 5.97501 4.06789 5.13098 4.2418 4.32274C4.41571 3.51451 4.88377 2.79974 5.5551 2.31723C6.22642 1.83471 7.05309 1.61889 7.87461 1.71166C8.69612 1.80444 9.45385 2.19919 10.0007 2.81927C10.3128 2.46375 10.6974 2.17908 11.1285 1.98433C11.5597 1.78958 12.0275 1.68927 12.5007 1.6901ZM10.834 8.35677H9.16732V16.6901H10.834V8.35677ZM7.50065 3.35677C7.06816 3.35483 6.65186 3.52109 6.33969 3.82042C6.02752 4.11974 5.84393 4.5287 5.8277 4.96088C5.81147 5.39307 5.96388 5.81464 6.25273 6.13653C6.54157 6.45842 6.94424 6.65543 7.37565 6.68593L7.50065 6.6901H9.16732V5.02343C9.16733 4.62515 9.02472 4.24003 8.76531 3.93781C8.5059 3.6356 8.14684 3.43627 7.75315 3.37593L7.62482 3.36093L7.50065 3.35677ZM12.5007 3.35677C12.0802 3.35663 11.6752 3.51544 11.3669 3.80135C11.0585 4.08726 10.8697 4.47914 10.8382 4.89843L10.834 5.02343V6.6901H12.5007C12.9211 6.69023 13.3261 6.53143 13.6344 6.24552C13.9428 5.95961 14.1316 5.56773 14.1632 5.14843L14.1673 5.02343C14.1673 4.58141 13.9917 4.15748 13.6792 3.84492C13.3666 3.53236 12.9427 3.35677 12.5007 3.35677Z",
    fill: "#0B4A96"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_947_26841"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.0234375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftFill);
export default __webpack_public_path__ + "static/media/gift-fill.1ac0c44c1f9aee2a127e7d7b66efbc64.svg";
export { ForwardRef as ReactComponent };